import { Component } from '@angular/core';

@Component({
    selector: 'vb-not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPageComponent {}
